import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { createLoadingSelector } from '../../../selectors/helpers';
import { getProductErrorsFromState } from '../../ticket-picker/selectors/selected-items';
import { getTotalSelectedProductsFromState } from '../../product-picker/selectors/products';
import { setDisplayConfigurationError } from '../../ticket-picker/actions/ticket-picker';
import InventoryConfigurationErrors from '../../ticket-picker/components/InventoryConfigurationErrors';
import { isKioskMode } from '../../../selectors/ui';
import { getSubState } from '../../../reducers/subReducerHelpers';
import { updateQuantities } from '../../../actions/reservation';
import { countCartedItemsForUpsell, getProductUpsellLoadingKey } from '../selectors/upsells';
import AddToOrderButton from '././AddToOrderButton';
import ProductContainer from '../../product-picker/containers/ProductContainer';

const getLoadingKeyFromProps = props => {
    return getProductUpsellLoadingKey(props.upsellId, props?.itemId);
}

/**
 * This wraps the upsell components for a single upsell item on a product type upsell
 */
class ProductUpsell extends Component {

    /**
     * Submit chosen inventory quantities to server if no errors
     */
    submitPicker = () => {
        const productsValid = Object.keys(this.getProductsWithErrors()).length === 0;
        if (!productsValid) {
            this.props.setDisplayConfigurationError(true, this.props.reducerKey);
            return false;
        } else {
            this.props.setDisplayConfigurationError(false, this.props.reducerKey);
        }
        this.props.updateQuantities(this.props.reducerKey, this.props.upsellId, null, getLoadingKeyFromProps(this.props));
    }

    getNumberSelectedProducts = () => {
        return getTotalSelectedProductsFromState(this.props.productQuantitiesArray);
    }

    getProductsWithErrors = () => {
        return getProductErrorsFromState(this.props.productQuantities, this.props.productConfigQuantities, this.props.productsList);
    }

    isDisabled = () => {
        return !!this.props.thisLoading || !!this.props.disabled;
    }

    render() {
        return(
            <>
                <ProductContainer
                    isProductUpsell={true}
                    displayTypeList={!!this.props.displayTypeList}
                    reducerKey={this.props.reducerKey}
                    productId={this.props.productId}
                    countCartedItems={this.props.countCartedItems}
                    canEdit={!!this.props.canEdit}
                    disabled={this.isDisabled()}
                />
                {!!this.props.displayConfigurationError &&
                    <div className="upsell-product__configuration-error-message">
                        <InventoryConfigurationErrors
                            productsWithErrors={this.getProductsWithErrors()}
                            isKioskMode={this.props.isKioskMode}
                        />
                    </div>
                }
                {this.getNumberSelectedProducts() > 0 && this.props.countCartedItems < 1 && (
                    <div className="upsell-product__add-to-order">
                        <AddToOrderButton
                            onClick={this.submitPicker}
                            loading={!!this.props.thisLoading}
                            disabled={this.isDisabled()}
                        />
                    </div>
                )}
            </>
        )
    }
}

const getReservationLoading = createLoadingSelector(["RESERVATION_CREATE", "RESERVATION_FETCH"]);
const mapStateToProps = (state, props) => {
    const ticketPickerState  = getSubState(state.ticketPicker, props.reducerKey);
    const productState       = getSubState(state.products, props.reducerKey);
    const productPickerState = getSubState(state.productPicker, props.reducerKey);
    const getThisLoading = createLoadingSelector([getLoadingKeyFromProps(props)]);
    return {
        locale: state.intl.locale,
        loading: getReservationLoading(state), // any reservation loading
        thisLoading: getThisLoading(state), // a request for this particular upsell loading
        productsList: productState.products,
        productQuantities: productPickerState.productsQuantities ?? {},
        productConfigQuantities: productPickerState.configQuantities ?? {},
        productQuantitiesArray: Object.values(productPickerState.productsQuantities ?? {}),
        displayConfigurationError: !!ticketPickerState?.displayConfigurationError,
        isKioskMode: isKioskMode(state),
        countCartedItems: countCartedItemsForUpsell(props.upsellId, null, false, props.productId)(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setDisplayConfigurationError,
        updateQuantities,
    }, dispatch);
}

ProductUpsell.propTypes = {
    upsellId: PropTypes.number,
    itemId: PropTypes.number,
    productId: PropTypes.number,
    reducerKey: PropTypes.string,
    canEdit: PropTypes.bool,
    displayTypeList: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductUpsell);
